import { useParams, useSearchParams } from "react-router-dom";
import { IBillingResponse } from "../../types/billing.types";
import { useGetInvoicePayment } from "../../hooks/queries/billing.queries";
import AddBillPaymentForm from "../AddBillPaymentForm/AddBillPaymentForm";
import { useFetchSessionNote } from "../../../../hooks/queries/note";
import PaymentItem from "../PaymentItem/PaymentItem";
import { cn } from "../../../../utils/helpers";
import Loader from "../../../../shared-ui/Loader/Loader";

interface IPaymentBreakdownProps {
    row: IBillingResponse;
    isExpanded: boolean;
}

export default function PaymentBreakdown({
    row,
    isExpanded,
}: IPaymentBreakdownProps) {
    const params = useParams();
    const [searchParams] = useSearchParams();
    const clientId = params.clientId as string;
    const noteId = params.noteId as string;

    const isEditingList = searchParams.getAll("editing_ids");

    const getInvoicePayload = {
        invoice_id: row.invoice_id,
    };

    const { data, isLoading, isSuccess } = useGetInvoicePayment(
        row.invoice_id,
        getInvoicePayload,
        isExpanded
    );

    const noteDetails = useFetchSessionNote(
        clientId,
        noteId,
        Boolean(clientId) && Boolean(noteId)
    );

    return (
        <div className="pt-12 bg-[--bg-primary-50]">
            <div
                className={cn(
                    "grid grid-cols-[170px_80px_200px_120px_100px_250px_260px_200px_100px_100px_318px_200px] gap-[--spacing-items] items-end px-[--padding-card-x] py-3 !text-[#576a81] text-caption font-semibold [border-bottom:1px_solid_rgba(0,0,0,0.1)]",
                    {
                        "grid-cols-[170px_80px_200px_120px_100px_370px_260px_200px_100px_100px_318px_200px]":
                            isEditingList.includes(row.invoice_id),
                    }
                )}
            >
                <span className="max-w-[170px]" />
                <span className="w-[80px]">CPT</span>
                <span className="w-[200px]">PAYMENT DATE</span>
                <span className="w-[100px]">SOURCE</span>
                <span className="w-[100px]">PAYMENT STATUS</span>
                <span className="w-[250px]">TYPE</span>
                <span className="w-[260px]">REMARK CODES</span>
                <span className="w-[200px]">PAYMENT AMOUNT</span>
                <span className="w-[100px]">EFT</span>
                <span className="w-[100px]">POSTED BY</span>
                <span className="w-[318px]">PAYMENT NOTE</span>
                <span className="w-[200px]">DESCRIPTION</span>
            </div>
            {isLoading ? (
                <Loader
                    className="[border:3px_solid_var(--color-stroke))] ![border-top:3px_solid_#1a738d]"
                    wrapperClassName="w-[50%]"
                />
            ) : null}
            {!isLoading && isSuccess
                ? data?.payment_breakdown?.map((item) => (
                      <PaymentItem key={item.payment_id} item={item} />
                  ))
                : null}

            <div className="px-[--padding-card-x] py-[--padding-card-y-lg] [border-bottom:1px_solid_var(--color-stroke)]">
                <AddBillPaymentForm
                    invoiceId={row.invoice_id}
                    claimId={noteDetails?.data?.data?.claim_id}
                    invoiceNoteId={noteId}
                />
            </div>
        </div>
    );
}
